import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';

import { MeuPerfilEditarPage } from './meu-perfil-editar.page';

const routes: Routes = [
  {
    path: '',
    component: MeuPerfilEditarPage
  }
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule],
})
export class MeuPerfilEditarPageRoutingModule {}
